import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import useAuth from '../../hooks/useAuth';
import ChatWindow from './ChatWindow';

function guestId() {
  let id = localStorage.getItem('tt_guest_id');
  if (!id) {
    id = `guest_${uuidv4()}`;
    localStorage.setItem('tt_guest_id', id);
  }
  return id;
}

/** Floating "chat with support" button for guests and logged-in users. Hidden for staff. */
export default function ChatLauncher() {
  const { t } = useTranslation();
  const { user, role } = useAuth();
  const [open, setOpen] = useState(false);

  if (role === 'ADMIN' || role === 'APPROVER') return null;

  const sender = user
    ? { id: user.id, name: [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email, type: 'USER' }
    : { id: guestId(), name: t('chat.guest'), type: 'GUEST' };

  return (
    <>
      {open && (
        <ChatWindow
          conversationId={sender.id}
          sender={sender}
          onClose={() => setOpen(false)}
        />
      )}
      {!open && (
        <button className="chat-fab" onClick={() => setOpen(true)} title={t('chat.withSupport')}>
          <i className="bi bi-chat-dots-fill" />
        </button>
      )}
    </>
  );
}
